const socketConfig = {
  //WEBSOCKET_URL: 'ws://192.168.43.71:8082', // Centralized WebSocket URL

  WEBSOCKET_URL: "ws://http://localhost:8082", // Centralized WebSocket URL

  // WEBSOCKET_URL: 'wss://getmeeza.com/prollix' // Centralized WebSocket URL
};

export default socketConfig;
